import { createStore } from "redux";
import rootReducer from "../services/storage";
const store = createStore(rootReducer);
export default store;
